const ITEMS = [
  "Firefighters",
  "Law Enforcement Officers",
  "Emergency Medical Personnel",
  "Emergency Dispatchers",
  "Military Veterans",
  "Palm Beach County",
  "Broward County",
  "South Florida",
];

export const Marquee = ({ items = ITEMS }) => (
  <div className="marquee border-y border-gold/30 bg-navy py-6 md:py-8" aria-hidden="true" data-testid="editorial-marquee">
    <div className="marquee-track">
      {[...items, ...items].map((item, i) => (
        <span key={i} className="flex items-center">
          <span className={`px-8 font-display text-2xl md:text-4xl font-extrabold uppercase tracking-tight ${i % 2 ? "outline-num !leading-none" : "text-paper"}`}>
            {item}
          </span>
          <svg viewBox="0 0 24 24" className="h-5 w-5 text-gold" fill="currentColor">
            <path d="M12 2l2.4 7.4H22l-6.2 4.5 2.4 7.4L12 16.8l-6.2 4.5 2.4-7.4L2 9.4h7.6z" />
          </svg>
        </span>
      ))}
    </div>
  </div>
);
